import React, { useEffect, useState } from "react";
import axios from "axios";

const STATUS_STYLES = {
  "Account Created": "bg-blue-100 text-blue-800",
  "Event Registered": "bg-yellow-100 text-yellow-800",
  "Event Payment Done": "bg-green-100 text-green-800",
};

const TopRepsAnalytics = () => {
  let JSToken;
  let accessToken;

  if (localStorage.user) {
    JSToken = JSON.parse(localStorage.user);
    accessToken = JSToken.access_token;
  }

  const config = {
    headers: { Authorization: `Bearer ${accessToken}` },
  };

  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get(`${window.$domain}/api/method/get_top_representative_stats`, config)
      .then((res) => {
        setData(res.data.message || {});
      })
      .catch((err) => {
        console.error("Failed to load analytics", err);
      })
      .finally(() => setLoading(false));
  }, []);

  const renderRepCard = (rep, index) => (
    <div
      key={rep.representative}
      className="flex items-center justify-between bg-gray-50 border rounded-lg p-3 shadow-sm hover:shadow-md transition"
    >
      <div>
        <p className="text-sm font-semibold text-gray-900">
          {index + 1}. {rep.full_name || "Unknown"}
        </p>
        <p className="text-xs text-gray-500">{rep.email || "N/A"}</p>
      </div>
      <span className="text-sm font-bold text-gray-800">{rep.count}</span>
    </div>
  );

  return (
    <div className="bg-white rounded-2xl shadow-md p-6">
      <h2 className="text-lg font-bold text-gray-800 mb-6">
        Top Representatives by Lead Status
      </h2>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {Object.keys(STATUS_STYLES).map((statusKey) => (
          <div
            key={statusKey}
            className="bg-white rounded-xl border p-4 flex flex-col shadow-sm"
          >
            <div
              className={`text-sm font-semibold px-3 py-2 rounded-md w-fit mb-3 ${STATUS_STYLES[statusKey]}`}
            >
              Top 20 – {statusKey}
            </div>

            <div className="space-y-3 max-h-[460px] overflow-y-auto pr-1">
              {loading ? (
                <div className="text-sm text-gray-500 animate-pulse">
                  Loading...
                </div>
              ) : data[statusKey]?.length ? (
                data[statusKey].map(renderRepCard)
              ) : (
                <div className="text-xs text-gray-400 italic">No data</div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TopRepsAnalytics;
